export default (date: Date | null) => {
    if (!date) return null;

    // Handle timezone before transforming date to iso string
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);

    return date.toISOString().split('T')[0];
};
